import { Component } from '@angular/core';

import * as smoothscroll from 'smoothscroll-polyfill';
import { LanguageSelectorComponent } from '../../language-selector/language-selector.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [LanguageSelectorComponent, TranslateModule],
})
export class HeaderComponent {
  constructor() {
    smoothscroll.polyfill();
  }

  scrollToDeposit(): void {
    const deposit = document.getElementById('deposit');
    deposit.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
